import React, { useRef } from "react";
import emailjs from "emailjs-com";
import { motion } from "framer-motion";
import "./Form.css";

const Form = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_njlmg8l",
        "template_cgo2vj5",
        form.current,
        "RJh4rouwJiwsTfORX"
      )
      .then(
        () => {
          alert("✅ Message sent successfully!");
          form.current.reset();
        },
        () => {
          alert("❌ Failed to send. Try again.");
        }
      );
  };

  return (
    <div className="contact-section">
      <motion.div
        className="contact-form"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          Get Solutions With Our Instructors
        </motion.h2>
        <p>Fill out the form and we will reach out to you shortly.</p>

        <motion.form
          ref={form}
          onSubmit={sendEmail}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          <div className="form-row">
            <motion.input
              whileFocus={{ scale: 1.02 }}
              type="text"
              name="user_name"
              placeholder="Full Name*"
              required
            />
            <motion.input
              whileFocus={{ scale: 1.02 }}
              type="email"
              name="user_email"
              placeholder="Email Address*"
              required
            />
          </div>

          <div className="form-row">
            <motion.input
              whileFocus={{ scale: 1.02 }}
              type="date"
              name="date"
              required
            />
            <motion.input
              whileFocus={{ scale: 1.02 }}
              type="text"
              name="subject"
              placeholder="Subject*"
              required
            />
          </div>

          <motion.textarea
            whileFocus={{ scale: 1.02 }}
            name="message"
            placeholder="Write your message..."
            rows="5"
            required
          ></motion.textarea>

          <motion.button
            type="submit"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Send Message
          </motion.button>
        </motion.form>
      </motion.div>
    </div>
  );
};

export default Form;
